/// <amd-module name="VSSUI/Components/FocusGroup/FocusGroup" />
import * as React from "react";
import { getSafeId, noop } from "VSSUI/Util";
import { IFocusGroup, IFocusGroupContext, IFocusGroupProps } from "./FocusGroup.Props";

export const FocusGroupContext = React.createContext<IFocusGroupContext>({
    onFocus: noop
});

export interface IFocusGroupState {
    defaultElementId?: string;
    focusedElementId?: string;
}

export class FocusGroup extends React.Component<IFocusGroupProps, IFocusGroupState> implements IFocusGroup {
    public static getDerivedStateFromProps(props: Readonly<IFocusGroupProps>, state: Readonly<IFocusGroupState>) {
        if (state.defaultElementId !== props.defaultElementId) {
            return { ...state, defaultElementId: props.defaultElementId, focusedElementId: props.defaultElementId };
        }
        return null;
    }

    public constructor(props: Readonly<IFocusGroupProps>) {
        super(props);
        this.state = { defaultElementId: props.defaultElementId, focusedElementId: props.defaultElementId };
    }

    public render() {
        return (
            <FocusGroupContext.Provider
                value={{
                    focusedElementId: this.state.focusedElementId,
                    onFocus: this.onFocus
                }}
            >
                {this.props.children}
            </FocusGroupContext.Provider>
        );
    }

    public focus(elementId?: string) {
        const id = getSafeId(elementId || this.state.focusedElementId);
        if (id) {
            const element = document.getElementById(id);
            if (element) {
                element.focus();
            }
        }
    }

    private onFocus = (focusedElementId: string) => {
        // Only setState if the focusedElement is changing. This prevents us from setting the state
        // when focus keeps getting fired on the same element. Example: Browser keeps losing and
        // getting focus.
        if (this.state.focusedElementId !== focusedElementId) {
            this.setState({ focusedElementId });
        }
    };
}
